import React from 'react';
import privacySideBarLinks from '../../data/privacyPolicy';

const PrivacyPolicySidebar = ({ active = '#general-definitions', onSelect }) => (
  <div>
    <h3 className="mb-4 font-bold">
      <strong>Table of Content:</strong>
    </h3>
    <ul className="text-alat-dimGrey font-openSans font-normal">
      {
        privacySideBarLinks.map((link) => (
          <li key={link.title} className={`${active === link.link ? 'border-l-4 border-alat-light text-alat-light' : ''} py-3 px-6 hover:text-alat-light`}>
            <button type="button" className="text-left w-full" onClick={() => onSelect?.(link.link)}>
              {link.title}
            </button>
          </li>
        ))
      }
    </ul>
  </div>
);

export default PrivacyPolicySidebar;
